export default __webpack_public_path__ + "static/media/cerrar.8548863a.svg";